// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "react18_ifl6/" + chunkId + "." + {"66":"95dd48e431f1439a6838","174":"f52536d26b714f10565b","538":"ca2fb33bc74811b0a485","644":"75ecd1acedd4521cae5a"}[chunkId] + ".js";
};